import { RiskLevelEnum } from "../..";

export enum RiskColorMatrixEnum {
  GREEN = "green",
  ORANGE = "orange",
  RED = "red",
}

export const getRiskByColor = (color?: string) => {
  switch (color) {
    case RiskColorMatrixEnum.GREEN:
      return RiskLevelEnum.LOW;
    case RiskColorMatrixEnum.ORANGE:
      return RiskLevelEnum.MEDIUM;
    case RiskColorMatrixEnum.RED:
      return RiskLevelEnum.HIGH;
    default:
      return "";
  }
};
